import { makeStyles } from "@inductiveautomation/ws-components";

export const getProfileStyles = makeStyles()((theme) => ({
  nonFullWidth: {
    width: "fit-content",
  },
  neutralEmailIcon: {
    color: theme.palette.neutral[50],
  },
}));

export const getEmailCardListStyles = makeStyles()((theme) => ({
  // TODO: (2024-12-10) Noah Settersten => Can we move this auto-truncation logic into the DataCard component? I took
  // a look into this and didn't find a straightforward way to accomplish it with CSS (JSS). We may be able to get a
  // ref to the text and dynamically calculate when it's overflowing the container and truncate it then.
  rootWithInfo: {
    ".MuiTypography-h3": {
      maxWidth: "calc(100vw - 288px)",

      [theme.breakpoints.down(349)]: {
        // When the info column is hidden, we can expand the text container
        maxWidth: "calc(100vw - 190px)",
      },
    },
  },
  rootWithoutInfo: {
    ".MuiTypography-h3": {
      maxWidth: "calc(100vw - 190px)",
    },
  },
}));
